import { ReactChild } from 'react';

import clsx from 'clsx';

import classes from './Text.module.css';

type TText = {
  // TODO: Update variant once this component becomes reusable
  variant: 'header' | 'subheader' | 'inherit';
  children: ReactChild;
  className?: string;
  'data-testid'?: string;
};

/**
 * DO NOT USE OUTSIDE OF LAYOUTCONTENT HEADER
 *
 * This Text component is just a concept at the moment.
 * Will be syncing with design team to align on styles for all text across partners.
 * Hoping to ease the effort on updating text across the app with this.
 * After sync we will actually return `h1` tag instead of div.
 * switch(variant) {
 *   case 'h1':
 *      return (
 *          <div className={classes.root}>
 *              <h1 className={className}>{text}</h1>
 *          </div>
 *      )
 * }
 *
 * This is only being used for LayoutContent header at the moment.
 */

function Text({
  variant,
  children: text,
  className,
  'data-testid': dataTestId,
}: TText) {
  switch (variant) {
    case 'header':
      return (
        <div className={classes.root} data-testid={dataTestId}>
          <div className={clsx(classes.header, className)}>{text}</div>
        </div>
      );
    case 'subheader':
      return (
        <div className={classes.root} data-testid={dataTestId}>
          <div className={clsx(classes.subheader, className)}>{text}</div>
        </div>
      );
    case 'inherit':
    default:
      return <div className={classes.root}>{text}</div>;
  }
}

export default Text;
